import {lazyInitialize, nonenumerable} from 'core-decorators';
import ModelState from './_util/model';
import APIRequestState from './_util/api-request';

class OrderUpdateState extends APIRequestState {
  get method() { return 'PUT'; }
  get url() { return '/orders'; }
}

class OrdersGetState extends ModelState {
  sanitizeModelId(id) { return parseFloat(id); }

  get url() { return '/orders'; }
  get singular() { return 'order'; }
  get plural() { return 'orders'; }
}

class OrdersEcomProductsGetState extends ModelState {
  get url() { return '/orders'; }
  get singular() { return 'product'; }
  get plural() { return 'products'; }
  get subUrl() { return 'ecommerce/products'; }

  getSingleRequest(model) {
    if (!this.url) {
      throw new Error('Missing option `url`');
    }
    if (!this.subUrl) {
      throw new Error('Missing option `subUrl`');
    }
    if (!this.singular) {
      throw new Error('Missing option `singular`');
    }
    if (!this.plural) {
      throw new Error('Missing option `plural`');
    }
    return this.ctx.sdk.get(`${this.url}/${model.id}/${this.subUrl}`);
  }
}

class OrdersState {
  @lazyInitialize @nonenumerable ordersGet = new OrdersGetState(this.ctx);
  @lazyInitialize @nonenumerable orderUpdate = new OrderUpdateState(this.ctx);
  @lazyInitialize @nonenumerable orderEcomProductsGet = new OrdersEcomProductsGetState(this.ctx);

  @nonenumerable
  listeners = [];

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }
}

export default OrdersState;



// WEBPACK FOOTER //
// ./spa/state/orders.jsx